import uuidMixin from 'vue/mixins/uuid';


export default function ariaMixin(ariaComponent) {
    return {
        mixins: [
            uuidMixin,
        ],
        methods: {
            ariaUid(ariaElement, ariaIdx) {
                const castAriaIdx = ariaIdx == null ? '' : ariaIdx.toString();
                const parts = [ariaComponent, this.uuid, ariaElement, castAriaIdx];
                return `${ parts.filter(Boolean).join('-') }`;
            },
        },
    };
};



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/mixins/aria/index.js